import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { injectIntl } from "react-intl"
import { Button, RichDescription, RichTitle } from ".."

const useStyles = makeStyles(theme => {
  return {
    background: {
      minHeight: "520px",
      position: "relative",
      "background-attachment": "fixed",
      "background-position": "center",
      "background-repeat": "no-repeat",
      "background-size": "cover",
    },
    caption: {
      margin: 0,
      "-ms-transform": "translateY(-50%)",
      transform: "translateY(-50%)",
      position: "absolute",
      top: "50%",
      width: "100%",
      textAlign: "center",
      color: theme.palette.white.main,
      fontFamily: theme.typography.fontFamily,
    },
    captionText: {
      fontSize: theme.spacing(4),
      fontWeight: 200,
      margin: "0 auto",
      textAlign: "center",
      maxWidth: "848px",
      [theme.breakpoints.down("md")]: {
        maxWidth: "70%",
      },
    },
    copy: {
      margin: "24px auto",
      textAlign: "left",
      fontSize: theme.spacing(2.3),
      maxWidth: "848px",
      [theme.breakpoints.down("md")]: {
        maxWidth: "70%",
      },
    },
    enableButton: {
      border: 0,
      "&:hover": {
        border: 0,
      },
    },
  }
})

export default injectIntl(props => {
  const classes = useStyles()
  const i18nmessages = props.intl.messages
  const handleClick = () => {
    window.location.href = props.item.ctaLink
  }

  return (
    <div
      className={classes.background}
      style={{ backgroundImage: `url(${props.item.backgroundImage.file.url})` }}
    >
      <div className={classes.caption}>
        {props.item.titleText && (
          <div className={classes.captionText}>
            {props.item.richTitle && (
              <RichTitle titleText={props.item.richTitle} />
            )}
          </div>
        )}
        <div className={classes.copy}>
          {props.item.richDescription && (
            <RichDescription copyText={props.item.richDescription} />
          )}
        </div>
        <div>
          <Button
            className={classes.enableButton}
            color={"white"}
            onClick={handleClick}
          >
            {i18nmessages.seeMore}
          </Button>
        </div>
      </div>
    </div>
  )
})
